// pages/Login.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';

function Login() {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [inviteToken, setInviteToken] = useState('');
    const [isRegistering, setIsRegistering] = useState(false);
    const [error, setError] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token) navigate('/dashboard');
    }, [navigate]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        try {
            let response;
            if (isRegistering) {
                response = await api.post('/auth/signup', { username, password, token: inviteToken });
            } else {
                response = await api.post('/auth/login', { username, password });
            }
            localStorage.setItem('token', response.data.token);
            document.cookie = `authToken=${response.data.token}; path=/; max-age=2592000`;
            navigate('/dashboard');
        } catch (err) {
            setError(isRegistering ? 'Registration failed' : 'Invalid username or password');
        }
    };

    return (
        <div className="login-container">
            <h2>{isRegistering ? 'Register' : 'Welcome'}</h2>
            {error && <p className="error">{error}</p>}
            <form onSubmit={handleSubmit}>
                <input 
                    className="text-input"
                    type="text" 
                    placeholder="Username" 
                    value={username} 
                    onChange={(e) => setUsername(e.target.value)} 
                    required 
                />
                <input 
                    className="text-input"
                    type="password" 
                    placeholder="Password" 
                    value={password} 
                    onChange={(e) => setPassword(e.target.value)} 
                    required 
                />
                {isRegistering && (
                    <input 
                        className="text-input"
                        type="text" 
                        placeholder="Invite Token" 
                        value={inviteToken} 
                        onChange={(e) => setInviteToken(e.target.value)} 
                        required 
                    />
                )}
                <button type="submit">{isRegistering ? 'Register' : 'Login'}</button>
            </form>
            <button className="toggle-btn" onClick={() => setIsRegistering(!isRegistering)}>
                {isRegistering ? 'Login' : 'Create account'}
            </button>
        </div>
    );
}

export default Login;
